import styled from 'styled-components';

import { color, spacing } from '~/theme';
interface StyledFormInlineErrorProps {
    type?: string;
}

const FormInlineError = styled.div<StyledFormInlineErrorProps>`
    color: ${props => (props?.type === 'error' ? color.palette.systemRed : color.palette.black)};
    margin-bottom: ${spacing.spacing4};
    display: flex;

    & span:first-of-type {
        position: relative;
        top: 3px;
        margin-right: ${spacing.spacing2};
    }
`;

export default FormInlineError;
